import groq from 'groq';

import { PRODUCT_SLUG } from './productSlug';

export const PRODUCT_FORMAT_FIELDS = groq`
  ${PRODUCT_SLUG},
  "formatLabel": coalesce(formatLabel, "Format label missing")
`;
